<template>
  <div>
    <vue-headful title="Contact Details" />

    <v-layout row wrap>
      <v-flex xs12>
        <StepTitle>Contact Details</StepTitle>
      </v-flex>

      <v-flex xs12>
        <FormSectionTitle>Your Information</FormSectionTitle>
        <ContactDetailsBox v-if="currentPerson" :contact="currentPerson" editable />
        <BaseAlert
          v-else
          :hg-value="true"
          hg-type="warning"
          id="no-user-error">
          Sorry, we couldn't find a User with that info
        </BaseAlert>
        <v-flex xs12 v-if="currentPerson.type === 'CUSTOMER'">
          <ContactRole />
        </v-flex>
        <v-flex xs12>
          <ContactSearch
            ref="contact-search"
            :formTitle="formTitles.additionalContacts[currentPerson.type]"
            :formDescription="formDescriptions.additionalContacts[currentPerson.type]"
            :listType="currentPerson.type === 'CUSTOMER' ?
             'CUSTOMER' : 'REAL_ESTATE_PROFESSIONAL'"/>
        </v-flex>

      </v-flex>

      <v-flex xs12>
        <ContactSearch
          ref="contact-search"
          :formTitle="formTitles.your_AccountType[currentPerson.type]"
          :formDescription="formDescriptions.your_AccountType[currentPerson.type]"
          :listType="currentPerson.type === 'CUSTOMER' ? 'REAL_ESTATE_PROFESSIONAL' : 'CUSTOMER'"/>
      </v-flex>

      <v-flex xs12  v-if="currentPerson.type !== 'CUSTOMER'">
        <ContactRole />
      </v-flex>
    </v-layout>
    <StepNavigation :continueDisabled="submitIsDisabled"/>
  </div>
</template>

<script>
import { Components, Constants } from '@spectorasoftware/homegauge-vue';
import { mapState } from 'vuex';

import FormSectionTitle from '@/components/FormSectionTitle.vue';
import StepNavigation from '@/components/StepNavigation.vue';
import ContactDetailsBox from '@/components/ContactDetailsBox.vue';
import ContactRole from '@/components/ContactRole.vue';
import ContactSearch from '@/components/ContactSearch.vue';
import StepTitle from '@/components/StepTitle.vue';
import RouteNameConstants from '@/router/constants/route-names';
import StepUtilities from '@/router/utilities/step-utilities';

const { BaseAlert } = Components;
const { AccountTypes } = Constants;
const formTitles = {
  additionalContacts: {
    [AccountTypes.REAL_ESTATE_PROFESSIONAL]: 'Additional Agent(s)',
    [AccountTypes.CUSTOMER]: 'Additional Contact(s)',
  },
  your_AccountType: {
    [AccountTypes.REAL_ESTATE_PROFESSIONAL]: 'Your Client(s)',
    [AccountTypes.CUSTOMER]: 'Your Agent(s)',
  },
};
const formDescriptions = {
  additionalContacts: {
    // eslint-disable-next-line max-len
    [AccountTypes.REAL_ESTATE_PROFESSIONAL]: 'Do you have another contact that you would like to receive the complete inspection report? (Example: Business partner, etc.)',
    // eslint-disable-next-line max-len
    [AccountTypes.CUSTOMER]: 'Do you have another contact that you would like to receive the complete inspection report? (Example: Spouse, Business partner, etc.)',
  },
  your_AccountType: {
    // eslint-disable-next-line max-len
    [AccountTypes.REAL_ESTATE_PROFESSIONAL]: 'Add your client so they receive the complete inspection report',
    // eslint-disable-next-line max-len
    [AccountTypes.CUSTOMER]: 'Add your agent so they receive the complete inspection report',
  },
};
export default {
  components: {
    BaseAlert,
    ContactDetailsBox,
    ContactRole,
    ContactSearch,
    FormSectionTitle,
    StepNavigation,
    StepTitle,
  },
  data() {
    return {
      errorList: [],
      searched: false,
      email: '',
      foundUser: {},
      apiLoading: false,
      addContactClicked: false,
      formTitles: {
        ...formTitles,
      },
      formDescriptions: {
        ...formDescriptions,
      },
    };
  },
  computed: {
    ...mapState('Appointment', {
      customerContacts: state => state.contactComponentData.contacts
        .filter(c => c.type === AccountTypes.CUSTOMER),
    }),
    ...mapState('Auth', {
      currentPerson: state => state.person,
    }),
    submitIsDisabled() {
      return this.currentPerson.type === AccountTypes.REAL_ESTATE_PROFESSIONAL
        && !this.customerContacts.length;
    },
  },
  mounted() {
    this.$store.commit('setStepIndex',
      StepUtilities.getStepIndexByRouteName(RouteNameConstants.AppointmentContact));
  },
};
</script>

<style lang="scss" scoped>
.add-person {
  padding-top: 20px;
}
</style>
